import React, { useState } from 'react';
import { Search, Menu, PenSquare, X } from 'lucide-react';

const ProjectItem = ({ project, isSelected, onClick, unreadCount }) => {
  const [hovered, setHovered] = useState(false);
  const bgColor = isSelected ? '#2b5278' : hovered ? '#1d3046' : 'transparent';
  const count = unreadCount || 0;

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '8px 12px',
        cursor: 'pointer',
        background: bgColor,
        transition: 'background 0.15s ease',
        userSelect: 'none',
      }}
    >
      <div style={{ position: 'relative', flexShrink: 0 }}>
        <div
          style={{
            width: '52px',
            height: '52px',
            borderRadius: '50%',
            background: project.color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#ffffff',
            fontWeight: 700,
            fontSize: '17px',
            letterSpacing: '0.5px',
          }}
        >
          {project.initials}
        </div>
        {project.isOnline && (
          <div
            style={{
              position: 'absolute',
              bottom: 1,
              right: 1,
              width: '13px',
              height: '13px',
              borderRadius: '50%',
              background: '#4dcd5e',
              border: `2px solid ${isSelected ? '#2b5278' : '#17212b'}`,
            }}
          />
        )}
      </div>

      <div style={{ flex: 1, marginLeft: '12px', minWidth: 0, overflow: 'hidden' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span
            style={{
              color: '#ffffff',
              fontWeight: 600,
              fontSize: '15px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: '175px',
            }}
          >
            {project.isProfile ? project.name : `Бот "${project.name}"`}
          </span>
          <span
            style={{
              color: count > 0 ? '#5288c1' : '#708499',
              fontSize: '12px',
              flexShrink: 0,
              marginLeft: '6px',
            }}
          >
            {project.lastActivity}
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '3px' }}>
          <span
            style={{
              color: '#708499',
              fontSize: '14px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              flex: 1,
            }}
          >
            {project.tagline}
          </span>
          {count > 0 && (
            <span
              style={{
                background: '#5288c1',
                color: '#ffffff',
                borderRadius: '12px',
                padding: '1px 7px',
                fontSize: '12px',
                fontWeight: 600,
                flexShrink: 0,
                marginLeft: '8px',
                minWidth: '20px',
                textAlign: 'center',
              }}
            >
              {count}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

const Sidebar = ({ projects, selectedId, onSelectProject, searchQuery, onSearchChange, unreadCounts, isMobile, onMenuClick }) => {
  const [menuHovered, setMenuHovered] = useState(false);
  const [penHovered, setPenHovered] = useState(false);

  return (
    <div
      style={{
        width: isMobile ? '100%' : '360px',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        background: '#17212b',
        borderRight: isMobile ? 'none' : '1px solid #0d1117',
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '0 14px',
          height: '56px',
          flexShrink: 0,
          borderBottom: '1px solid rgba(255,255,255,0.04)',
        }}
      >
        <button
          onMouseEnter={() => setMenuHovered(true)}
          onMouseLeave={() => setMenuHovered(false)}
          onClick={onMenuClick}
          style={{
            background: menuHovered ? 'rgba(255,255,255,0.08)' : 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '8px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background 0.15s ease',
          }}
        >
          <Menu size={20} color="#708499" />
        </button>
        <span
          style={{
            flex: 1,
            color: '#ffffff',
            fontWeight: 600,
            fontSize: '18px',
            marginLeft: '8px',
            letterSpacing: '-0.2px',
          }}
        >
          Портфолио
        </span>
        <button
          onMouseEnter={() => setPenHovered(true)}
          onMouseLeave={() => setPenHovered(false)}
          style={{
            background: penHovered ? 'rgba(255,255,255,0.08)' : 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '8px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background 0.15s ease',
          }}
        >
          <PenSquare size={18} color="#708499" />
        </button>
      </div>

      <div style={{ padding: '8px 12px 4px', flexShrink: 0 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            background: '#212d3b',
            borderRadius: '22px',
            padding: '8px 14px',
            gap: '8px',
          }}
        >
          {searchQuery ? (
            <button
              onClick={() => onSearchChange('')}
              style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex' }}
            >
              <X size={15} color="#5288c1" />
            </button>
          ) : (
            <Search size={15} color="#708499" />
          )}
          <input
            value={searchQuery}
            onChange={e => onSearchChange(e.target.value)}
            placeholder="Поиск"
            style={{
              flex: 1,
              background: 'transparent',
              border: 'none',
              outline: 'none',
              color: '#ffffff',
              fontSize: '15px',
              caretColor: '#5288c1',
            }}
          />
        </div>
      </div>

      <div
        style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}
        className="tg-scrollbar"
      >
        {projects.length > 0 ? (
          projects.map(project => (
            <ProjectItem
              key={project.id}
              project={project}
              isSelected={String(selectedId) === String(project.id)}
              onClick={() => onSelectProject(project)}
              unreadCount={(unreadCounts || {})[String(project.id)] || 0}
            />
          ))
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '48px 24px',
              color: '#708499',
              fontSize: '14px',
              textAlign: 'center',
            }}
          >
            <Search size={36} color="#3e4e5e" style={{ marginBottom: '12px' }} />
            Ничего не найдено
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
